export function randomAvatarColor(nameString: string) {
  let hash = 0;
  let i;
  for (i = 0; i < nameString.length; i += 1) {
    hash = nameString.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
}

export function getNameInitials(name: string | undefined) {
  if (!name) {
    return '';
  }
  const matches = name.match(/\b(\w)/g) || [];
  return matches.join('').toUpperCase();
}

export function getContrastColor(colorHex: string) {
  const r = parseInt(colorHex.substring(1, 2), 16);
  const g = parseInt(colorHex.substring(3, 2), 16);
  const b = parseInt(colorHex.substring(5, 2), 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? 'black' : 'white';
}
